import { useSelector } from '../../../../../store'

export const useUserPresence = (userId: string) => {
  const presence = useSelector((state) => state.presence.status[userId])
  return presence ?? 'loading'
}
